'use strict';

const wishlist = require('../product/wishlist');
const search = require('base/search/search');
const tnyMain = require('../tny_main');
const {encodeHtml} = require('sswd_base/util/XStringUtils');

/**
 * Ajaxの結果でDOM要素を更新する
 *
 * @param {object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 */
function updateDom($results, selector) {
    let $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Ajaxリフレッシュ後も絞り込みペインの展開/折りたたみを維持する
 *
 * @param {object} $results - jQuery DOM element
 * @returns {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        let activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Ajaxの結果を解析し、選択したDOM要素を更新する
 *
 * @param {string} response - Ajax response HTML code
 * @returns {undefined}
 */
function parseResults(response) {
    let $results = $(response);
    let specialHandlers = {
        '.refinements': handleRefinements,
    };

    // 特別な処理を必要としないDOM要素の更新
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.refinements-checked',
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Ajax応答からソートオプション URL を更新します
 *
 * @param {string} response - Ajax response HTML code
 * @returns {undefined}
 */
function updateSortOptions(response) {
    let $tempDom = $('<div>').append($(response));
    let sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * エラーメッセージを表示するポップアップを作成する
 * @param {Object} message - エラーメッセージ
 */
function createErrorNotification(message, button) {
    const errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        encodeHtml(message) +
        '</div>';

    // カートメッセージのCSSを利用
    $('body').append('<div class="add-to-cart-messages"></div>');
    $('.add-to-cart-messages').append(errorHtml);
    setTimeout(function () {
        $('.add-to-cart-messages').remove();
        button.removeAttr('disabled');
    }, 5e3);
}

/**
 * 絞込みバーを閉じます。
 */
function closeSlide() {
    $('.slide-bar').toggleClass('is-active');
    $('.search-overlay').remove();
}

// SFRAのsearchを継承
let exportsSearch = $.extend({}, search, {
    // module.exports = {
    showSlideRefineBar: function () {
        // 絞り込みバーの表示
        $(document).on('click', '.slide-btn', function (e) {
            e.preventDefault();
            $('.slide-bar').toggleClass('is-active');
            $('body').append('<div class="search-overlay"></div>');
            // 絞り込みメニュー以外の画面押下で閉じる
            $('.search-overlay').on('click', closeSlide);
        });
    },

    closeSlideRefineBar: function () {
        // 絞り込みバーをたたむ
        $(document).on('click', '.slide-close', function (e) {
            e.preventDefault();
            closeSlide();
        });
    },

    // applyRefine: function () {
    applyFilter: function () {
        // 絞り込み値の選択とリセットクリックの操作
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar1 button.reset',
            function (e) {
                e.preventDefault();

                // 親要素のクリックイベントが発生させない
                e.stopPropagation();

                // 0件絞込みの場合はアラート表示
                let refinelimit = $(this).data('refinelimit');
                if (refinelimit) {
                    let button = $(this);
                    button.attr('disabled', true);
                    let message = $(this).data('refinelimitmessage');
                    createErrorNotification(message, button);
                    return;
                }

                $.spinner().start();
                $(this).trigger('search:filter', e);
                let attributeId = $(this).find('span').last().attr('id');

                if ($(this).hasClass('reset')) {
                    // すべてのフィルターボタンを削除する
                    $('.filter-button').remove();
                }

                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href'),
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        tnyMain.addObserverFadeIn();
                        $.spinner().stop();
                        $('#' + attributeId)
                            .parent('button')
                            .focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $('#' + attributeId)
                            .parent('button')
                            .focus();
                    },
                });
            }
        );
    },

    closeFilterButton: function () {
        $(document).on('click', '.filter-button .close-button', function (e) {
            // 親要素のクリックイベントが発生させない
            e.stopPropagation();
            $.spinner().start();

            // フィルターボタン取得
            let filterButton = $(this).closest('.filter-button');

            // フィルタのURLを取得
            let filterHref = filterButton.data('href');

            // フィルター領域で該当するフィルターのチェックを外す
            let filterInList = $('.refinements li button[data-href="' + filterHref + '"]');
            if (filterInList) {
                filterInList.find('i').removeClass('fa-check-square-o').addClass('fa-square-o');
            }

            // フィルターボタンを外す
            filterButton.remove();

            $.ajax({
                url: filterHref,
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    tnyMain.addObserverFadeIn();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            let showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {selectedUrl: showMoreUrl},
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    tnyMain.addObserverFadeIn();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    sort: function () {
        // ソート
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            // 親要素のクリックイベントが発生させない
            e.stopPropagation();
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: {selectedUrl: this.value},
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    tnyMain.addObserverFadeIn();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },
});

module.exports = exportsSearch;

module.exports.addToWishlist = wishlist.addToWishlist();

module.exports.addObserverFadeIn = tnyMain.addObserverFadeIn();
